import React from 'react'
import { observer } from 'mobx-react-lite'

import { Stack } from '@mui/material'

import { DebtsPriorityButton } from '../debtspriority/DebtsPriorityButton'
import { DebtsPriorityPopover } from '../debtspriority/DebtsPrioriyPopover'

import { useGlobalCopyStore, useEvent, ANALYTICS_EVENTS } from '../../../common'
import { useDebtsUiStore } from '../../hooks/useDebtsUiStore'
import { DebtPriority } from '../../../core/constants/Debts'

interface DebtsPriorityActionProps {
  disabled?: boolean
  isDesktop?: boolean
}

export const DebtsPriorityAction = observer(({ disabled, isDesktop }: DebtsPriorityActionProps) => {
  const { onEvent } = useEvent()
  const { debts: copy } = useGlobalCopyStore()
  const { selectedDebtPriority } = useDebtsUiStore()

  const [buttonEl, setButtonEl] = React.useState<HTMLButtonElement | null>(null)

  const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setButtonEl(event.currentTarget)
    onEvent(ANALYTICS_EVENTS.DEBTS_CLICK_PRIORITIZE)
  }

  const handleClose = () => {
    setButtonEl(null)
  }

  const isOpen = Boolean(buttonEl)

  const buttonText = React.useMemo(() => {
    const priorityMap = {
      [DebtPriority.FASTEST_PAYOFF_FIRST]: copy.priority_sort_fastest_payoff,
      [DebtPriority.HIGHEST_INTEREST]: copy.priority_sort_highest_interest,
      [DebtPriority.HIGHEST_BALANCE]: copy.priority_sort_highest_balance,
      [DebtPriority.LOWEST_BALANCE]: copy.priority_sort_lowest_balance,
    }
    return priorityMap[selectedDebtPriority] ?? copy.priority_sort_lowest_balance
  }, [selectedDebtPriority])

  return (
    <Stack>
      <DebtsPriorityButton
        buttonText={buttonText}
        disabled={disabled}
        isDesktop={isDesktop}
        isOpen={isOpen}
        onClick={handleOpen}
      />
      <DebtsPriorityPopover buttonEl={buttonEl} onClose={handleClose} />
    </Stack>
  )
})
